import {Component, computed, inject, input, signal} from '@angular/core';
import {Router} from '@angular/router';
import {CarouselModule} from 'primeng/carousel';
import {TranslocoPipe} from '@jsverse/transloco';
import {ExtendedHrTool} from '../hr-tool.types';
import {HrToolService} from '../hr-tool.service';
import {APP_ROUTES} from '../../../app.routes';

interface HrToolOrPlaceholder extends ExtendedHrTool {
  isPlaceholder?: boolean;
}

@Component({
  selector: 'app-similar-tool',
  imports: [CarouselModule, TranslocoPipe],
  templateUrl: './similar-hr-tools.component.html',
})
export class SimilarToolsComponent {
  private readonly hrToolsService = inject(HrToolService);
  private readonly router = inject(Router);

  readonly excludeId = input('');

  constructor() {
    // Populate the catalog list when arriving directly on a detail page (not via the catalog grid).
    this.hrToolsService.ensureToolsLoaded();
  }

  realSimilar = computed<ExtendedHrTool[]>(() =>
    this.hrToolsService.hrTools().filter((tool) => tool.id !== this.excludeId()),
  );

  allSimilar = computed<HrToolOrPlaceholder[]>(() => {
    const real = this.realSimilar();
    if (real.length === 0) {
      return [];
    }
    const needed = Math.max(0, 4 - real.length);
    const placeholders = Array.from(
      {length: needed},
      (_, index) => ({id: `ph-${index}`, isPlaceholder: true}) as HrToolOrPlaceholder,
    );
    return [...real, ...placeholders];
  });

  isCircular = computed(() => this.realSimilar().length > 4);

  viewport = signal<{numVisible: number; numScroll: number}>({numVisible: 4, numScroll: 1});

  protected navigate(tool: ExtendedHrTool): void {
    void this.router.navigate([APP_ROUTES.HR_TOOLS, tool.id]);
  }

  protected hideBrokenImage(event: Event): void {
    (event.target as HTMLImageElement).style.display = 'none';
  }
}
